<template>
  <section class="news-container">
    <home-banner></home-banner>
    <section class="Product">
      <div class="header">
        <!--      <el-tabs-->
        <!--        v-model="activeTab"-->
        <!--        @tab-click="tabClick">-->
        <!--        <el-tab-pane-->
        <!--          v-for="(tab, index) in tabList"-->
        <!--          :key="index"-->
        <!--          :label="tab.label"-->
        <!--          :name="String(tab.name)"-->
        <!--        ></el-tab-pane>-->
        <!--      </el-tabs>-->
        <span class="title">Homepage Promotion</span>
        <div class="filter-top-select">
          <span
            v-for="(item,index) in tabList"
            :key="'select'+index"
            :class="{'is_active':activeTab==item.name}"
            @click="handleChange(item.name)">{{item.label}}</span>
        </div>
        <div class="btn">
          <v-button
            v-if="activeTab != 4"
            gray
            @click="routerToPromoDetail">New Promotion</v-button>
          <v-button
            v-else
            gray
            @click="newTag">New Tag</v-button>
        </div>
      </div>
      <div
        v-show="activeTab != 4">
        <section
          ref="sortable"
          class="content-container">
          <div
            v-for="val in detailList"
            :key="val.promotion_id"
            class="item">
            <div
              class="img"
              @click="routerToPromoDetail(val)">
              <img :src="val.data[0].cover_image_url">
            </div>
            <div class="footer">
              <div class="info">
                <p class="item_title"><span>{{val.data[0].title}}</span><span>{{val.data[1].title}}</span><span
                  v-if="val.private"
                  class="private">Private</span></p>
                <p class="time">{{val.start_date | delTime}} - {{val.end_date | delTime}}</p>
              </div>
              <span
                class="icon"
                @mousedown="handleClick(val)"
                @mouseenter="handleMouseEnter"
                @mouseleave="handleMouseLeave">
                <font-awesome-icon icon="grip-lines" />
              </span>
            </div>
          </div>
        </section>
      </div>
      <tag-list
        v-show="activeTab == 4"
        ref="tag"></tag-list>
      <div
        v-if="!hasData"
        class="no_data">No Data</div>
    </section>
    <section class="Product">
      <div class="header">
        <span class="title">Product Promotion</span>
        <div class="filter-top-select">
          <span
            v-for="(item,index) in productTabList"
            :key="'select'+index"
            :class="{'is_active':activeProductTab==item.name}"
            @click="handleProductChange(item.name)">{{item.label}}</span>
        </div>
        <div class="btn">
          <v-button
            gray
            @click="routerToProductPromoDetail()">New Promotion</v-button>
        </div>
      </div>
      <div>
        <section
          ref="sortableProduct"
          class="content-container">
          <div
            v-for="val in detailProductList"
            :key="val.promotion_id"
            class="item">
            <div
              class="img"
              @click="routerToProductPromoDetail(val)">
              <img :src="val.data[0].cover_image_url">
              <span
                class="top-tag"
              >{{getOptionData('classOptions',val.class_id).name}}</span>
            </div>
            <div class="footer">
              <div class="info">
                <p class="item_title"><span>{{val.data[0].title}}</span><span>{{val.data[1].title}}</span><span
                  v-if="val.private"
                  class="private">Private</span></p>
                <p class="time">{{val.start_date | delTime}} - {{val.end_date | delTime}}</p>
              </div>
              <span
                class="icon"
                @mousedown="handleProductClick(val)"
                @mouseenter="handleProductMouseEnter"
                @mouseleave="handleProductMouseLeave">
                <font-awesome-icon icon="grip-lines" />
              </span>
            </div>
          </div>
        </section>
      </div>
      <div
        v-if="!hasProductData"
        class="no_data">No Data</div>
    </section>
    <section class="Product">
      <div class="header">
        <span class="title">Result Page Ad Image</span>
        <div class="filter-top-select">
          <span
            v-for="(item,index) in productTabList"
            :key="'select'+index"
            :class="{'is_active':activeProductADTab==item.name}"
            @click="handleProductADChange(item.name)">{{item.label}}</span>
        </div>
        <div class="btn">
          <v-button
            gray
            @click="routerToProductPromoADDetail">New Promotion</v-button>
        </div>
      </div>
      <div>
        <section
          ref="sortableADProduct"
          class="content-container">
          <div
            v-for="val in detailProductADList"
            :key="val.promotion_id"
            class="item">
            <div
              class="img"
              @click="routerToProductPromoADDetail(val)">
              <img :src="val.data[0].cover_image_url">
            </div>
            <div class="footer">
              <div class="info">
                <p class="item_title"><span>{{val.data[0].title}}</span><span>{{val.data[1].title}}</span><span
                  v-if="val.private"
                  class="private">Private</span></p>
                <p class="time">{{val.start_date | delTime}} - {{val.end_date | delTime}}</p>
              </div>
              <span
                class="icon"
                @mousedown="handleProductADClick(val)"
                @mouseenter="handleProductADMouseEnter"
                @mouseleave="handleProductADMouseLeave">
                <font-awesome-icon icon="grip-lines" />
              </span>
            </div>
          </div>
        </section>
      </div>
      <div
        v-if="!hasProductAdData"
        class="no_data">No Data</div>
    </section>
  </section>
</template>
<script>
import {getPromotionsList, promoSort} from '@/api/news'
import {getPromotionProductList, sortPromotionProduct} from '@api/promotion'
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import TagList from '../../tag-list.vue'
import Sortable from 'sortablejs'
import homeBanner from '@/views/administration/home-banner'

export default {
  name: 'NewContainer',
  components:{
    homeBanner,
    TagList
  },
  filters:{
    delTime(val){
      const change = (arr) => {
        let y = arr[0]
        let m = arr[1]
        let d = arr[2]
        return `${d}-${m}-${y}`
      }
      let arr = val.split(' ')
      return change(arr[0].split('-'))
    }
  },
  mixins: [MixinOptions],
  data() {
    return {
      activeTab: '1',
      activeProductTab: '1',
      activeProductADTab: '1',
      tabList: [
        {
          name: '1',
          label: 'Current'
        },
        {
          name: '2',
          label: 'Upcoming'
        },
        {
          name: '3',
          label: 'Past'
        },
        {
          name: '4',
          label: 'Tags'
        }
      ],
      productTabList: [
        {
          name: '1',
          label: 'On'
        },
        {
          name: '2',
          label: 'Off'
        },
        {
          name: '3',
          label: 'Past'
        },
      ],
      detailList:[],
      detailProductList:[],
      detailProductADList:[],
      promotion_id: ''
    }
  },
  computed:{
    ...mapState('news',['activeTag']),
    hasData(){
      return this.detailList.length != 0
    },
    hasProductData(){
      return this.detailProductList.length != 0
    },
    hasProductAdData(){
      return this.detailProductADList.length != 0
    }
  },
  mounted(){
    this.activeTab = this.activeTag||'1'
    this.network().getList()
    this.network().getPromotionProductList()
    this.network().getPromotionADProductList()
    let el = this.$refs['sortable']
    let productEl = this.$refs['sortableProduct']
    let productADEl = this.$refs['sortableADProduct']
    this.createSort(el)
    this.createProductSort(productEl)
    this.createProductADSort(productADEl)
  },
  methods: {
    ...mapActions('news',['setTag']),
    handleChange(data){
      this.activeTab = data
      if(data!=4)
        this.network().getList()
    },
    handleProductChange(data){
      this.activeProductTab = data
      this.network().getPromotionProductList()
    },
    handleProductADChange(data){
      this.activeProductADTab = data
      this.network().getPromotionADProductList()
    },
    routerToProductPromoDetail(val){
      let {promotion_id} = val||{}
      this.$router.push({
        name: 'PromotionsProductDetail',
        query:{
          promotion_id,
        }
      })
    },
    routerToProductPromoADDetail(val){
      let {promotion_id} = val||{}
      this.$router.push({
        name: 'PromotionsProductADDetail',
        query:{
          promotion_id,
        }
      })
    },
    routerToPromoDetail(val) {
      this.setTag(this.activeTab)
      if(val){
        this.$router.push({
          name: 'PromotionsDetail',
          query:{
            id: val.promotion_id,
          }
        })
      }else{
        this.$router.push({
          name: 'PromotionsDetail',
        })
      }
    },

    newTag(){
      this.$refs['tag'].tag_id = -1
      this.$refs['tag'].changeDialog()
    },

    tabClick(){
      if(this.activeTab != 4){
        this.network().getList()
      }
    },

    handleMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.sortable.option('disabled', true)
    },
    handleProductADMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.productADSortable.option('disabled', true)
    },
    handleProductMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.productSortable.option('disabled', true)
    },
    handleMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.sortable.option('disabled', false)
    },
    handleProductMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.productSortable.option('disabled', false)
    },
    handleProductADMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.productADSortable.option('disabled', false)
    },

    handleClick(val) {
      this.promotion_id = val.promotion_id
    },
    handleProductClick(val) {
      this.promotion_id = val.promotion_id
    },
    handleProductADClick(val) {
      this.promotion_id = val.promotion_id
    },
    sortEnd(e) {
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          promotion_id: this.promotion_id,
          old_index: e.oldIndex,
          new_index: e.newIndex
        }
        this.network().promoSort(params)
      }
    },
    sortProductEnd(e) {
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          promotion_id: this.promotion_id,
          old_index: e.oldIndex,
          new_index: e.newIndex,
          category_type:4
        }
        this.network().sortPromotionProduct(params)
      }
    },
    sortProductAdEnd(e) {
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          promotion_id: this.promotion_id,
          old_index: e.oldIndex,
          new_index: e.newIndex,
          category_type:5
        }
        this.network().sortPromotionAdProduct(params)
      }
    },

    createSort(el){
      this.sortable = new Sortable(el,{
        disabled: true,
        onEnd: this.sortEnd
      })
    },
    createProductSort(el){
      this.productSortable = new Sortable(el,{
        disabled: true,
        onEnd: this.sortProductEnd
      })
    },
    createProductADSort(el){
      this.productADSortable = new Sortable(el,{
        disabled: true,
        onEnd: this.sortProductAdEnd
      })
    },
    network(){
      return {
        getList: async () => {
          let params = {
            status: this.activeTab,
          }
          const {data} = await getPromotionsList(params)
          if(Array.isArray(data)){
            this.detailList = data
          }else{
            this.detailList = []
          }
        },
        getPromotionProductList: async () => {
          let params = {
            promotion_status: this.activeProductTab,
            category_type:4
          }
          if(this.activeProductTab==3){
            delete params.promotion_status
            params.status = this.activeProductTab
          }
          const {data} = await getPromotionProductList(params)
          if(Array.isArray(data)){
            this.detailProductList = data
          }else{
            this.detailProductList = []
          }
        },
        getPromotionADProductList: async () => {
          let params = {
            promotion_status: this.activeProductADTab,
            category_type:5
          }
          if(this.activeProductADTab==3){
            delete params.promotion_status
            params.status = this.activeProductADTab
          }
          const {data} = await getPromotionProductList(params)
          if(Array.isArray(data)){
            this.detailProductADList = data
          }else{
            this.detailProductADList = []
          }
        },
        promoSort: async (params) => {
          const {data} = await promoSort(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
          this.network().getList()
        },
        sortPromotionProduct: async (params) => {
          const {data} = await sortPromotionProduct(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
          this.network().getPromotionProductList()
        },
        sortPromotionAdProduct: async (params) => {
          const {data} = await sortPromotionProduct(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
          this.network().getPromotionADProductList()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .header{
    position: relative;
    .title{
      font-weight: 600;
      font-size: 24px;
      height: 36px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
      margin-bottom: 15px;
    }
    .btn{
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .content-container{
    display: flex;
    flex-wrap: wrap;
    .item{
      margin:0 20px 20px 0;
      .img{
        cursor: pointer;
        height: 112px;
        width: 217px;
        border: 1px solid #E1E4E8;
        box-sizing: border-box;
        border-radius: 6px;
        margin: 10px 0px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .top-tag{
        background: #E1E4E8;
        color: $dark;
        padding: 3px 5px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 600;

      }
      .footer{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .info{
          p{
            width: 182px;
          }
          .item_title{
            font-family: Inter;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
            color: #24292E;
            overflow-wrap: break-word;
            span + span{
              margin: 0 10px;
            }
          }
          .time{
            font-family: Inter;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            color: #6A737D;
          }
          .private{
            color: rgba(88, 96, 105, 1);
            font-size: 12px;
            line-height: 18px;
            font-weight: 600;
            border: 1px solid rgba(225, 228, 232, 1);
            // width: 58px;
            height: 18px;
            border-radius: 100px;
            padding: 0 8px;
            margin: 0 !important;
          }
        }
        .icon{
          width: 16px;
          font-style: normal;
          font-weight: 900;
          font-size: 16px;
          line-height: 20px;
          color: #D1D5DA;
          flex: 1;
          text-align: center;
          padding: 8px;
        }
      }
    }
  }
  .no_data{
    line-height: 60px;
    color: #909399;
    text-align: center;
  }
}
.filter-top-select{
  margin-bottom: 15px;
  border-bottom: 1px solid #E1E4E8;
  //padding-bottom: 16px;
  display: flex;
  span{
    padding: 12px 16px 10px 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #586069;
    display: block;
    cursor: pointer;
    &.is_active{
      color: #24292E;
      border: 1px solid #E1E4E8;
      border-bottom: 0;
      background: #f8f8f8;
      margin-bottom: -1px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:first-child{
      margin-left: 10px;
    }
  }
}
</style>
